























































import { Component, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { ITemplateChannel } from "@/models/templates";
import { DataModules } from "@/store/modules/data";
import { mapState } from "vuex";
import { IState } from "@/store";
import { FilterOperators } from "@/data/table";
import { serialiseConfig, serialiseFilter } from "@/helpers/table";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { TemplateTypes } from "@/data/enums/templates";

@Component({
  computed: {
    ...mapState({
      channels(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.NOTIFICATIONS_CHANNELS
        });
      }
    })
  },
  components: {
    "templates-provider": () =>
      import("@/components/app/global/templates/templatesProvider.vue"),
    "templates-notifications-table-view": () =>
      import(
        "@/components/app/global/templates/notifications/templatesNotificationsTableView.vue"
      )
  }
})
export default class AutomationActions extends Mixins(RequestPromises) {
  public isLoading = true;
  public channelFilter = "";
  public totalActions = {};
  public channels!: ITemplateChannel[];
  public templateType = TemplateTypes.NOTIFICATION;

  public async created() {
    try {
      await this.getChannels();
      await this.getActionsCount();
      this.isLoading = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  public async getChannels() {
    return this.$store.dispatch(
      `data/${DataModules.NOTIFICATIONS_CHANNELS}/list`,
      {
        vm: this,
        params: {
          order: "id",
          limit: 0
        }
      }
    );
  }

  public async getActionsCount() {
    const response = await this.$store.dispatch(
      `data/${DataModules.TEMPLATES}/list`,
      {
        vm: this,
        storeData: false,
        returnData: false,
        params: {
          limit: "count",
          "filter[type]": TemplateTypes.NOTIFICATION,
          group_count: "channel_id"
        }
      }
    );

    this.$_.forEach(this.channels, channel => {
      const total = this.$_.find(response.total, ["channel_id", channel.id]);
      this.$set(this.totalActions, channel.id, this.$_.get(total, "total", 0));
    });
  }

  public get channelCode() {
    const tableParams = this.$route.query["AAT"] as string;
    if (this.$_.isEmpty(tableParams)) {
      return 0;
    }
    const channelRegex = `${NotificationChannelCodes.EMAIL}|${NotificationChannelCodes.IN_APP}|${NotificationChannelCodes.SLACK}`;

    const match = tableParams.match(
      new RegExp(/channel.code\|=\|/.source + new RegExp(channelRegex).source)
    );

    if (match === null) {
      return 0;
    }
    return match[0].replace(
      serialiseFilter({
        key: "channel.code",
        operator: FilterOperators.EQUAL,
        value: ""
      }),
      ""
    );
  }

  public getChannelRoute(channel: ITemplateChannel) {
    let tableParams = serialiseConfig({
      constFilters: [
        {
          key: "channel.code",
          operator: FilterOperators.EQUAL,
          value: channel.code
        }
      ]
    });
    if (this.channelCode === channel.code) {
      tableParams = "";
    }
    return {
      name: "adminAutomationChannels",
      query: { AAT: tableParams }
    };
  }

  public beforeDestroy() {
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.NOTIFICATIONS_CHANNELS,
      vm: this
    });
  }

  public get filteredChannels() {
    return this.$_.orderBy(
      this.$_.filter(this.channels, ch =>
        ch.name.toLowerCase().includes(this.channelFilter.toLowerCase())
      ),
      ["_order"],
      ["asc"]
    );
  }

  public highlight = (needle, haystack) =>
    haystack.replace(
      new RegExp(needle, "gi"),
      str => `<span class="has-text-info">${str}</span>`
    );
}
